import { render } from "./AddPlatFormCostSetting.vue?vue&type=template&id=21de7f4b&scoped=true"
import script from "./AddPlatFormCostSetting.vue?vue&type=script&lang=js"
export * from "./AddPlatFormCostSetting.vue?vue&type=script&lang=js"

import "./AddPlatFormCostSetting.vue?vue&type=style&index=0&id=21de7f4b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21de7f4b"]])

export default __exports__